import * as yup from 'yup';
import I18n from '../localization';
import {E_WALLET_MINIMUM_TOPUP_VALUE,E_WALLET_MAXIMUM_TOPUP_VALUE} from '../../config'

yup.addMethod(yup.string, 'customEmail', function (ref, msg) {
    return this.test('customEmail', msg, (value) => {
        const emailRegex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const diacriticsRegex = /^[a-zA-Z0-9_.-À-ÖØ-öø-ÿ]/;
        return value === undefined || (emailRegex.test(value) && diacriticsRegex.test(value));
    });
});

yup.addMethod(yup.string, 'notEqualTo', function (ref, msg) {
    return this.test('notEqualTo', msg, function (value) {
        return value !== this.resolve(ref);
    });
});

// @ts-ignore
yup.addMethod(yup.string, 'equalTo', (ref, msg) =>
    yup.mixed().test({
        name: 'equalTo',
        exclusive: false,
        message: msg || '${path} must be the same as ${reference}',
        params: {
            reference: ref.path,
        },
        test(value) {
            return value === this.resolve(ref);
        }
    }),
);

export const loginValidationSchema = yup.object().shape({
    username: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('username'), I18n.t('validation.email'))
        .required(I18n.t('validation.required')),
    password: yup.string().required(I18n.t('validation.required'))
});

export const loginVerificationValidationSchema = yup.object().shape({
    email: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('username'), I18n.t('validation.email'))
        .required(I18n.t('validation.required'))
});

export const registerValidationSchema = yup.object().shape({
    firstName: yup.string().max(50, I18n.t('validation.max', { number: 50 })),
    lastName: yup.string().max(50, I18n.t('validation.max', { number: 50 })),
    email: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('email'), I18n.t('validation.email'))
        .required(I18n.t('validation.required'))
        .max(100, I18n.t('validation.max', { number: 100 })),
    password: yup.string().required(I18n.t('validation.required')),
    passwordConfirm: yup
        .string()
        // @ts-ignore
        .equalTo(yup.ref('password'), I18n.t('validation.passwordsDiffer'))
        .required(I18n.t('validation.required')),
    areTermsOfUseAccepted: yup
        .boolean()
        .oneOf([true], I18n.t('register.form.areTermsOfUseAcceptedErrorMessage'))
});

export const forgotPasswordValidationSchema = yup.object().shape({
    email: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('email'), I18n.t('validation.email'))
        .required(I18n.t('validation.required'))
});

export const resetPasswordValidationSchema = yup.object().shape({
    password: yup.string().required(I18n.t('validation.required')),
    confirmPassword: yup
        .string()
        // @ts-ignore
        .equalTo(yup.ref('password'), I18n.t('validation.passwordsDiffer'))
        .required(I18n.t('validation.required'))
});

export const changePasswordValidationSchema = yup.object().shape({
    oldPassword: yup.string().required(I18n.t('validation.required')),
    newPassword: yup
        .string()
        // @ts-ignore
        .notEqualTo(yup.ref('oldPassword'), I18n.t('validation.passwordsEqual'))
        .required(I18n.t('validation.required')),
    confirmPassword: yup
        .string()
        // @ts-ignore
        .equalTo(yup.ref('newPassword'), I18n.t('validation.passwordsDiffer'))
        .required(I18n.t('validation.required'))
});

export const updateUserValidationSchema = yup.object().shape({
    firstName: yup.string().max(50, I18n.t('validation.max', { number: 50 })),
    lastName: yup.string().max(50, I18n.t('validation.max', { number: 50 })),
    email: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('email'), I18n.t('validation.email'))
        .required(I18n.t('validation.required'))
        .max(100, I18n.t('validation.max', { number: 100 }))
});

export const topUpEWalletAnonymousValidationSchema = yup.object().shape({
    cardNumber: yup.string().required(I18n.t('validation.required')),
    email: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('email'), I18n.t('validation.email'))
        .required(I18n.t('validation.required'))
        .max(100, I18n.t('validation.max', { number: 100 })),
    areTermsOfUseAccepted: yup
        .boolean()
        .oneOf([true], I18n.t('areTermsOfUseAcceptedErrorMessage')),
    amount: yup.number()
        .required(I18n.t('validation.amountRequired'))
        .min(E_WALLET_MINIMUM_TOPUP_VALUE,I18n.t('validation.minimumAmount'))
        .max(E_WALLET_MAXIMUM_TOPUP_VALUE,I18n.t('validation.maximumAmount'))
});

export const topUpEWalletValidationSchema = yup.object().shape({
    areTermsOfUseAccepted: yup
        .boolean()
        .oneOf([true], I18n.t('areTermsOfUseAcceptedErrorMessage')),
    amount: yup.number()
        .required(I18n.t('validation.amountRequired'))
        .min(E_WALLET_MINIMUM_TOPUP_VALUE,I18n.t('validation.minimumAmount'))
        .max(E_WALLET_MAXIMUM_TOPUP_VALUE,I18n.t('validation.maximumAmount'))
});

export const getCardInfoValidationSchema = yup.object().shape({
    cardSerialNumber: yup.string().required(I18n.t('validation.required'))
});

export const activateProfilePhysicalValidationSchema = yup.object().shape({
    cardNumber: yup
        .string()
        .required(I18n.t('validation.required'))
        .max(20, I18n.t('validation.max', { number: 20 })),
    oib: yup
        .string()
        .required(I18n.t('validation.required'))
        .max(11, I18n.t('validation.max', { number: 11 })),
    areTermsAccepted: yup
        .boolean()
        .oneOf([true], I18n.t('areTermsAcceptedErrorMessage'))
});

export const activateProfileMobileValidationSchema = yup.object().shape({
    verificationCode: yup
        .string()
        .required(I18n.t('validation.required'))
        .max(12, I18n.t('validation.max', { number: 12 })),
    areTermsAccepted: yup
        .boolean()
        .oneOf([true], I18n.t('areTermsAcceptedErrorMessage'))
});


export const getPenaltyValidationSchema = yup.object().shape({
    referenceNumber: yup.string().required(I18n.t('validation.required')),
});

export const penaltyPayValidationSchema = yup.object().shape({
    email: yup
        .string()
        // @ts-ignore
        .customEmail(yup.ref('email'), I18n.t('validation.email'))
        .required(I18n.t('validation.required'))
        .max(100, I18n.t('validation.max', { number: 100 })),
    areTermsOfUseAccepted: yup
        .boolean()
        .oneOf([true], I18n.t('areTermsOfUseAcceptedErrorMessage')),
});
